import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { balanceReportParamsSelector } from './reducer';



export const balanceReportApi = createApi({
  reducerPath: 'balanceReportApi',
  tagTypes: ['BalanceReport', 'EndOfDayTime'],
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('X-Token', token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getBalanceHistory: builder.query({
      // limit/offset бекенд не принимает — только start/end
      query: ([start, end]) => {
        const params = [];

        if (start) {
          const formattedStart = `${start.getDate()}/${(start.getMonth() + 1).toString().padStart(2, '0')}/${start.getFullYear()}`;
          params.push(`start=${formattedStart}`);
        }

        if (end) {
          const formattedEnd = `${end.getDate()}/${(end.getMonth() + 1).toString().padStart(2, '0')}/${end.getFullYear()}`;
          params.push(`end=${formattedEnd}`);
        }

        return params.length ? `/admin/end-of-day/history?${params.join('&')}` : '/admin/end-of-day/history';
      },
      providesTags: ['BalanceReport'],
    }),
    getCurrentEndOfDayTime: builder.query({
      query: () => `/admin/end-of-day/get-time`,
      providesTags: ['EndOfDayTime'],
    }),
    setEndOfDayTime: builder.mutation({
      query: ({ hour, minute }) => ({
        url: `/admin/end-of-day/set-time?hour=${hour}&minute=${minute}`,
        method: 'POST',
      }),
      invalidatesTags: ['EndOfDayTime'],
    }),
  }),
});

export const {
  useGetBalanceHistoryQuery,
  useGetCurrentEndOfDayTimeQuery,
  useSetEndOfDayTimeMutation,
} = balanceReportApi;

export { balanceReportParamsSelector }; 